import angular from 'angular';

/**
 * @ngdoc function
 * @name myConsultApp.controller:storyList
 * @description
 * # storyList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('storyList', ($http, ENV, $scope, $location, $compile) => {
    if (!$scope.isSuperUser && !$scope.isAdminUser) {
      $location.path('/');
    }

    const currentDate = new Date();
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);

    $scope.mediaObj = [];

    $scope.init = () => {
      $scope.getBrandsAndCampaigns();
    };

    $scope.getImageUrl = async (fileKey) => {
      const apiUrl = `${ENV.sfmcAssetsBaseUrl}/webservice/ugc-token`;

      try {
        const { data } = await $http.post(apiUrl, { file_key: fileKey });
        return data.tokenized_url;
      } catch (error) {
        console.error(error);
      }
    };

    $scope.openImage = (fileKey) => {
      const apiUrl = `${ENV.sfmcAssetsBaseUrl}/webservice/ugc-token`;

      $http.post(apiUrl, { file_key: fileKey }).then(({ data }) => {
        window.open(data.tokenized_url, '_blank');
      });
    };

    $scope.viewImage = async (fileKey, fileType) => {
      const imageUrl = await $scope.getImageUrl(fileKey);
      $scope.mediaObj = [
        {
          index: 1,
          id: 1,
          thumbnail: null,
          storage_url: imageUrl,
          tokenized_url: null,
          mime_type: {
            type: {
              slug: fileType.match('image') !== null ? 'image' : 'video',
            },
          },
        },
      ];

      $scope.createModal(
        `<div class="admin-modal centered image-preview-modal">
            <div><media-viewer class="media-player" static-media="mediaObj" suppress-errors="true" /></div>
            <div class="buttons">
              <button ng-click="openImage('${fileKey}'); hideModal()">
                Download
              </button>
              <button ng-click="hideModal()">
                Close
              </button>
            </div>
          </div>
          <div class="admin-overlay-modal">
          </div>`,
      );
    };

    $scope.getBrandsAndCampaigns = () => {
      const campaignData = {
        '@search.facets': {
          brand: [
            {
              value: 'Apoquel',
            },
            {
              value: 'Cytopoint',
            },
            {
              value: 'Librela',
            },
            {
              value: 'Simparica Trio',
            },
            {
              value: 'Solensia',
            },
            {
              value: 'ZPC',
            },
          ],
          campaign: [
            {
              value: 'Adopter Sweepstakes',
            },
            {
              value: 'apoquel-share-your-story',
            },
            {
              value: 'cytopoint-share-story',
            },
            {
              value: 'cytopoint-share-your-story',
            },
            {
              value: 'librela-share-your-story',
            },
            {
              value: 'pet-mental-health-2021',
            },
            {
              value: 'rewards-submit-your-story',
            },
            {
              value: 'simparica-gotcha-day',
            },
            {
              value: 'simparica-trio-share-your-story',
            },
            {
              value: 'solensia-share-your-story',
            },
          ],
        },
      };

      const apiUrl = `${ENV.apiEndpoint}${$scope.storyTable.options.endpoint}`;
      const params = {
        facets: ['campaign,sort:count', 'brand,sort:count'],
      };

      $http.get(apiUrl, params, { withCredentials: false }).then(() => {
        const { brand, campaign } = campaignData['@search.facets'];

        const updateFilterChoices = (index, choices) => {
          const defaultValue = { label: '-- None --', value: '' };

          $scope.storyTable.filters[index].options.choices = [
            defaultValue,
            ...choices.map((elem) => ({ label: elem.value, value: elem.value })),
          ];

          $scope.storyTable.filters[index].options.selected = defaultValue;
        };

        updateFilterChoices(1, brand);
        updateFilterChoices(2, campaign);
      });
    };

    $scope.createModal = async (content) => {
      angular.element(document.querySelector('.admin-overlay-modal')).remove();
      angular.element(document.querySelector('.admin-modal')).remove();
      const $body = $(content);
      const temp = $compile($body)($scope);
      await angular.element(document.body).append(temp);
      setTimeout(() => {
        angular.element(document.querySelector('.admin-modal')).addClass('display');
      }, 150);
    };

    $scope.storyTable = {
      name: 'Share Your Story Submissions',
      options: {
        endpoint: '/2.0/media/story-list/',
        pageSizeOptions: [15, 25, 50, 100, 200],
        pageSize: 15,
        showDownloadButton: true,
      },
      columns: [
        {
          name: 'Submission Date',
          options: {
            content: `{{ record.submission_date | date:'short' }}`,
          },
        },
        {
          name: 'Submission ID',
          options: {
            content: '{{ record.submission_id }}',
          },
        },
        {
          name: 'User',
          options: {
            content: `<a href="#" ng-href="/admin/users/manage-users/{{ record.subscriberKey }}">
                {{ record.subscriberKey }}
              </a><br/>{{ record.first_name }} {{ record.last_name }}<br/>{{ record.emailAddress }}`,
          },
        },
        {
          name: 'Pet',
          options: {
            content: `{{ record.pet_species }} - <a href="#" ng-href="/admin/users/manage-users/{{ record.subscriberKey }}/pet-detail/{{ record.pet_id }}">{{ record.pet_name }}</a><br/>{{ record.pet_id }}`,
          },
        },
        {
          name: 'Brand',
          options: {
            content: '{{ record.brand }}',
          },
        },
        {
          name: 'Campaign',
          options: {
            content: '{{ record.campaign }}',
          },
        },
        {
          name: 'Story',
          options: {
            content: '{{ record.story_text }}',
            class: 'limit-width',
          },
        },
        {
          name: 'Story 2',
          options: {
            content: '{{ record.story_text_2 }}',
            class: 'limit-width',
          },
        },
        {
          name: 'Story 3',
          options: {
            content: '{{ record.story_text_3 }}',
            class: 'limit-width',
          },
        },
        {
          name: 'Image',
          options: {
            content: `<a ng-if="record.file_type.includes('image') || record.file_type.includes('video')" href="#" ng-click="viewImage(record.file_key, record.file_type)">View</a>&nbsp;&nbsp;
            <a ng-if="record.file_type.includes('image') || record.file_type.includes('video')" href="#" ng-click="openImage(record.file_key)">Download</a>`,
          },
        },
      ],
      filters: [
        {
          name: 'Date Range',
          type: 'date_range',
          key: 'submission_date',
          options: {
            class: 'date-range-filter',
            from: {
              required: true,
              queryString: 'ge',
              value: monthAgo,
            },
            to: {
              required: true,
              queryString: 'le',
              value: currentDate,
            },
          },
        },
        {
          name: 'Brand',
          type: 'dropdown',
          key: 'brand',
          options: {
            show: false,
            placeholder: 'Select',
            choices: [],
            selected: {},
          },
        },
        {
          name: 'Campaign',
          type: 'dropdown',
          key: 'campaign',
          options: {
            show: false,
            placeholder: 'Select',
            choices: [],
            selected: {},
          },
        },
      ],
      sortOptions: {
        submission_date: {
          state: true,
          value: '-1',
          title: 'Submission Date',
          order: 0,
        },
      },
    };

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
